import type { ReactElement } from "react";
import WebGLIframe from "./WebGLIframe";
import { Android, IPad, Iphone, MacOS, MetaQuest, Pico, WebGL, Windows10, Scorm } from "./index";

interface IconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  stroke?: string;
  style?: string;
}

interface Props {
  platform: string;
  iconProps?: IconProps;
  inTable?: boolean;
  scormVersion?: string | null;
}

export default function PlatformIcon({
  platform,
  iconProps = { width: "50px", height: "50px", fill: "black", style: "mr-fix-important" },
  inTable = false,
  scormVersion = undefined,
}: Props): ReactElement {
  switch (platform) {
    case "OculusQuest":
    case "MetaQuest":
      return (
        <MetaQuest {...iconProps} style={iconProps.style} width="90px" height={iconProps.height} />
      );
    case "Unknown":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={iconProps.width}
          height={iconProps.height}
          fill="none"
          viewBox="0 0 24 24"
          stroke={iconProps.fill || "currentColor"}
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
          />
        </svg>
      );
    case "PicoNeo":
      return <Pico {...iconProps} style={iconProps.style} width="50px" height={iconProps.height} />;
    case "Android":
      return (
        <Android
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "iPhone":
    case "IPhone":
      return (
        <Iphone
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "iPad":
    case "IPad":
      return (
        <IPad
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "MacOS":
      return (
        <MacOS
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "Windows10":
    case "Windows 64bit":
    case "Windows64bit":
    default:
      return (
        <Windows10
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "WebGLApp_scorm":
      return <Scorm fill={iconProps.fill} stroke={iconProps.stroke} width={30} height={30} />;
    case "WebGLApp":
    case "WebGL App":
      if (scormVersion) {
        return <Scorm fill={iconProps.fill} stroke={iconProps.stroke} width={30} height={30} />;
      }
      return (
        <WebGL
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "WebGLiframe":
    case "WebGL iframe":
      return (
        <WebGLIframe
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width ?? 55}
          height={iconProps.height ?? 55}
          inTable={inTable}
        />
      );
  }
}
